import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import PropTypes, { intlPropType } from '../../helpers/propTypes';
import { Title } from '../typography';
import NavigationProgressItem from './NavigationProgressItem';

const messages = defineMessages({
  closeDialog: {
    id: 'Modal.CloseDialog',
    defaultMessage: 'Close dialog',
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 1000,
    backgroundColor: 'white',

    '@media print': {
      display: 'none',
    },
  },

  upper: {
    borderBottom: '1px solid #ccc',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: 72,

    [theme.breakpoints.down('xs')]: {
      height: 40,
    },
  },

  closeButton: {
    position: 'absolute',
    right: 16,
    color: 'black',

    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },

  lower: {
    borderBottom: '1px solid #ccc',
  },
}));

function NavigationProgress({
  progress,
  handleModalClose,
  navItems,
  isHidden,
  showCloseButton,
  titleId,
  intl: { formatMessage },
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.upper}>
        <Title id={titleId} variant="h4">
          <FormattedMessage
            defaultMessage="Sign up for study"
            id="NavigationProgress.SignUp"
          />
        </Title>
        {showCloseButton && (
          <IconButton
            aria-label={formatMessage(messages.closeDialog)}
            className={classes.closeButton}
            onClick={handleModalClose}
          >
            <Close />
          </IconButton>
        )}
      </div>
      {!isHidden && (
        <div aria-hidden="true" className={classes.lower}>
          <Grid container direction="row">
            {navItems &&
              navItems.map(({ label, index }) => (
                <NavigationProgressItem
                  key={label.key}
                  index={index}
                  item={label}
                  progress={progress}
                />
              ))}
          </Grid>
        </div>
      )}
    </div>
  );
}

NavigationProgress.propTypes = {
  handleModalClose: PropTypes.func.isRequired,
  intl: intlPropType.isRequired,
  isHidden: PropTypes.bool,
  navItems: PropTypes.arrayOf(PropTypes.node).isRequired,
  progress: PropTypes.number.isRequired,
  showCloseButton: PropTypes.bool.isRequired,
  titleId: PropTypes.string.isRequired,
};

NavigationProgress.defaultProps = {
  isHidden: false,
};

export default injectIntl(NavigationProgress);
